import React from "react";
import { ArrowRight, Phone, MapPin } from "lucide-react";
import { Button } from "./ui/button";
import { setConsultSource } from "../lib/consultSource";

export function HeroBackdrop() {
  return (
    <>
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1568667256549-094345857637?w=1920&q=85" alt="Law library" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0c1729]/85" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0c1729]/95 via-[#0c1729]/70 to-[#0c1729]/95" />
      </div>
      {/* Decorative double-line frame; top edge sits below the fixed navbar */}
      <div className="absolute inset-x-8 bottom-8 top-24 md:inset-x-12 md:bottom-12 md:top-28 border border-white/10 pointer-events-none" />
      <div className="absolute inset-x-10 bottom-10 top-[6.5rem] md:inset-x-14 md:bottom-14 md:top-[7.5rem] border border-white/5 pointer-events-none" />
    </>
  );
}

export function HeroActions() {
  return (
    <div className="mt-12 flex flex-wrap gap-4 justify-center">
      <Button asChild className="rounded-none h-12 px-9 bg-[#b8924a] hover:bg-[#a07f3e] text-white uppercase tracking-[0.2em] text-[11px] font-medium border border-[#b8924a]">
        <a href="#attorneys">Meet Our Attorneys <ArrowRight className="w-4 h-4 ml-3" /></a>
      </Button>
      <Button asChild variant="outline" className="rounded-none h-12 px-9 border border-white/40 text-white bg-transparent hover:bg-white hover:text-[#0c1729] uppercase tracking-[0.2em] text-[11px] font-medium">
        <a href="#contact" onClick={() => setConsultSource("Home page — hero button")}>Schedule a Consultation</a>
      </Button>
    </div>
  );
}

export function HeroOfficeLines({ firm }) {
  return (
    <div className="mt-16 inline-grid grid-cols-[auto_auto] gap-x-8 gap-y-3 text-sm text-stone-300 text-left" data-testid="hero-office-lines">
      {firm.offices.map((office, i) => {
        const phone = firm.phones[i];
        const city = office.city.toLowerCase();
        return (
          <React.Fragment key={office.city}>
            {phone ? (
              <a href={`tel:${phone.replace(/\D/g, "")}`} className="flex items-center gap-2 hover:text-white transition" data-testid={`hero-phone-${city}`}>
                <Phone className="w-4 h-4 text-[#d4b87a]" /> {phone}
              </a>
            ) : (
              <span />
            )}
            <a href={office.mapUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition underline-offset-4 hover:underline" data-testid={`hero-map-${city}`}>
              <MapPin className="w-4 h-4 text-[#d4b87a]" /> {office.city}, {office.state}
            </a>
          </React.Fragment>
        );
      })}
    </div>
  );
}
